"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _variables = _interopRequireDefault(require("./style/variables"));

var _theme = _interopRequireDefault(require("./Popup/theme"));

var _popup = _interopRequireDefault(require("./Popup/theme/popup"));

var _confirm = _interopRequireDefault(require("./Popup/theme/confirm"));

var _alert = _interopRequireDefault(require("./Popup/theme/alert"));

var _theme2 = _interopRequireDefault(require("./DateInput/theme"));

var _theme3 = _interopRequireDefault(require("./DatePicker/theme"));

var _theme4 = _interopRequireDefault(require("./MonthPicker/theme"));

var _theme5 = _interopRequireDefault(require("./MonthInput/theme"));

var _theme6 = _interopRequireDefault(require("./Button/theme"));

var _theme7 = _interopRequireDefault(require("./Input/theme"));

var _theme8 = _interopRequireDefault(require("./CardInput/theme"));

var _theme9 = _interopRequireDefault(require("./CardSelect/theme"));

var _theme10 = _interopRequireDefault(require("./Checkbox/theme"));

var _theme11 = _interopRequireDefault(require("./Control/theme"));

var _theme12 = _interopRequireDefault(require("./DropDown/theme"));

var _theme13 = _interopRequireDefault(require("./DropDownFilter/theme"));

var _theme14 = _interopRequireDefault(require("./DropDownSearch/theme"));

var _theme15 = _interopRequireDefault(require("./ErrorComponent/theme"));

var _theme16 = _interopRequireDefault(require("./IconButton/theme"));

var _theme17 = _interopRequireDefault(require("./Hint/theme"));

var _theme18 = _interopRequireDefault(require("./Pagination/theme"));

var _theme19 = _interopRequireDefault(require("./Phone/theme"));

var _theme20 = _interopRequireDefault(require("./PlainText/theme"));

var _theme21 = _interopRequireDefault(require("./Preloader/theme"));

var _theme22 = _interopRequireDefault(require("./Progress/theme"));

var _theme23 = _interopRequireDefault(require("./Radio/theme"));

var _theme24 = _interopRequireDefault(require("./RadioGroup/theme"));

var _theme25 = _interopRequireDefault(require("./SeparatedInput/theme"));

var _theme26 = _interopRequireDefault(require("./TextArea/theme"));

var _theme27 = _interopRequireDefault(require("./Autocomplete/theme"));

var _theme28 = _interopRequireDefault(require("./ControlHint/theme"));

var _theme29 = _interopRequireDefault(require("./ErrorHint/theme"));

var _theme30 = _interopRequireDefault(require("./Interval/theme"));

var _theme31 = _interopRequireDefault(require("./Link/theme"));

var _theme32 = _interopRequireDefault(require("./ModuleTitle/theme"));

var _theme33 = _interopRequireDefault(require("./Options/theme"));

var _theme34 = _interopRequireDefault(require("./PinBlock/theme"));

var _theme35 = _interopRequireDefault(require("./QRCode/theme"));

var _theme36 = _interopRequireDefault(require("./Slider/theme"));

var _theme37 = _interopRequireDefault(require("./SwitchCheckbox/theme"));

var _theme38 = _interopRequireDefault(require("./Table/theme"));

var _theme39 = _interopRequireDefault(require("./Tabs/theme"));

var _theme40 = _interopRequireDefault(require("./Toggler/theme"));

var _theme41 = _interopRequireDefault(require("./TutorialHint/theme"));

var _theme42 = _interopRequireDefault(require("./SearchInput/theme"));

var _theme43 = _interopRequireDefault(require("./Divider/theme"));

var _theme44 = _interopRequireDefault(require("./SnackBar/theme"));

var _theme45 = _interopRequireDefault(require("./Menu/theme"));

var _theme46 = _interopRequireDefault(require("./Skeleton/theme"));

var _theme47 = _interopRequireDefault(require("./DebitSource/theme"));

var _theme48 = _interopRequireDefault(require("./Paper/theme"));

var _theme49 = _interopRequireDefault(require("./Stepper/theme"));

var _theme50 = _interopRequireDefault(require("./DropDownButton/theme"));

var _theme51 = _interopRequireDefault(require("./Label/theme"));

var _theme52 = _interopRequireDefault(require("./Underscore/theme"));

var _deepmerge = _interopRequireDefault(require("deepmerge"));

var _context = _interopRequireDefault(require("./context"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var getValue = function getValue(custom) {
  custom = custom || {};

  var computedPalette = _objectSpread({}, _variables["default"], {}, custom.palette);

  return (0, _deepmerge["default"])({
    palette: computedPalette,
    modal: (0, _theme["default"])(computedPalette),
    dateInput: (0, _theme2["default"])(computedPalette),
    datepicker: (0, _theme3["default"])(computedPalette),
    monthPicker: (0, _theme4["default"])(computedPalette),
    monthInput: (0, _theme5["default"])(computedPalette),
    button: (0, _theme6["default"])(computedPalette),
    cardInput: (0, _theme8["default"])(computedPalette),
    input: (0, _theme7["default"])(computedPalette),
    cardSelect: (0, _theme9["default"])(computedPalette),
    checkbox: (0, _theme10["default"])(computedPalette),
    control: (0, _theme11["default"])(computedPalette),
    dropDown: (0, _theme12["default"])(computedPalette),
    dropDownFilter: (0, _theme13["default"])(computedPalette),
    dropDownSearch: (0, _theme14["default"])(computedPalette),
    errorComponent: (0, _theme15["default"])(computedPalette),
    iconButton: (0, _theme16["default"])(computedPalette),
    hint: (0, _theme17["default"])(computedPalette),
    pagination: (0, _theme18["default"])(computedPalette),
    phone: (0, _theme19["default"])(computedPalette),
    plainText: (0, _theme20["default"])(computedPalette),
    preloader: (0, _theme21["default"])(computedPalette),
    progress: (0, _theme22["default"])(computedPalette),
    radio: (0, _theme23["default"])(computedPalette),
    radioGroup: (0, _theme24["default"])(computedPalette),
    separatedInput: (0, _theme25["default"])(computedPalette),
    textArea: (0, _theme26["default"])(computedPalette),
    autocomplete: (0, _theme27["default"])(computedPalette),
    controlHint: (0, _theme28["default"])(computedPalette),
    errorHint: (0, _theme29["default"])(computedPalette),
    interval: (0, _theme30["default"])(computedPalette),
    link: (0, _theme31["default"])(computedPalette),
    moduleTitle: (0, _theme32["default"])(computedPalette),
    options: (0, _theme33["default"])(computedPalette),
    pinBlock: (0, _theme34["default"])(computedPalette),
    qrCode: (0, _theme35["default"])(computedPalette),
    slider: (0, _theme36["default"])(computedPalette),
    snackBar: (0, _theme44["default"])(computedPalette),
    switchCheckbox: (0, _theme37["default"])(computedPalette),
    table: (0, _theme38["default"])(computedPalette),
    tabs: (0, _theme39["default"])(computedPalette),
    toggler: (0, _theme40["default"])(computedPalette),
    tutorialHint: (0, _theme41["default"])(computedPalette),
    searchInput: _objectSpread({}, (0, _theme7["default"])(computedPalette), {}, (0, _theme42["default"])(computedPalette)),
    confirmModal: (0, _confirm["default"])(computedPalette),
    alertModal: (0, _alert["default"])(computedPalette),
    popup: (0, _popup["default"])(computedPalette),
    divider: (0, _theme43["default"])(computedPalette),
    menu: (0, _theme45["default"])(computedPalette),
    skeleton: (0, _theme46["default"])(computedPalette),
    debitSource: (0, _theme47["default"])(computedPalette),
    paper: (0, _theme48["default"])(computedPalette),
    stepper: (0, _theme49["default"])(computedPalette),
    dropDownButton: (0, _theme50["default"])(computedPalette),
    label: (0, _theme51["default"])(computedPalette),
    underscore: (0, _theme52["default"])(computedPalette)
  }, custom);
};

var ThemeProvider = function ThemeProvider(_ref) {
  var theme = _ref.theme,
      children = _ref.children;
  var value = (0, _react.useMemo)(function () {
    return getValue(theme);
  }, [theme]);
  return _react["default"].createElement(_context["default"].Provider, {
    value: value
  }, children);
};

ThemeProvider.propTypes = {
  theme: _propTypes["default"].object,
  children: _propTypes["default"].any
};
var _default = ThemeProvider;
exports["default"] = _default;